import React, { useState } from "react";
import { signIn } from "../services/auth";

interface Props {
  onSignIn: () => void;
}

export function LoginPage({ onSignIn }: Props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await signIn(email, password);
      onSignIn();
    } catch (err: any) {
      setError(err.message ?? "Sign in failed");
    }
  };

  return (
    <div style={{ maxWidth: 360, margin: "80px auto", padding: 24 }}>
      <h2>SOP Voice — Sign In</h2>
      <form onSubmit={handleSubmit}>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="Email" required style={{ display: "block", width: "100%", padding: 8, marginBottom: 12 }} />
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
          placeholder="Password" required style={{ display: "block", width: "100%", padding: 8, marginBottom: 16 }} />
        {error && <p style={{ color: "red" }}>{error}</p>}
        <button type="submit" style={{ width: "100%", padding: 12, background: "#1976d2", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer" }}>
          Sign In
        </button>
      </form>
    </div>
  );
}
